import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContent, Typography } from '@mui/material';


type UploadEDResultProps = {
    success: string[],
    fail: string[],
}

const UploadEDResult = ({success, fail}: UploadEDResultProps) => {
    const {t} = useTranslation();

    return (
        <DialogContent>
            {success.length > 0 && (
                <>
                    <Typography>{t('successfully_uploaded')}</Typography>
                    <ol>
                        {success.map(s => <li key={s}>{s}</li>)}
                    </ol>
                </>
            )}
            {fail.length > 0 && (
                <>
                    <Typography>Can't find this shippers</Typography>
                    <ol>
                        {fail.map(s => <li key={s}>{s}</li>)}
                    </ol>
                </>
            )}
        </DialogContent>
    );
};

export default UploadEDResult;
